'use strict';

const extractExportTypes = {
  hasu: 'hasu',
  aoc: 'aoc',
  integration: 'integration',
};

const extractFileTypes = {
  zip: 'zip',
  xlsx: 'xlsx',
  csv: 'csv',
  json: 'json',
};

const extractExportSubTypes = {
  spaceTest: 'spaceTest',
};

module.exports = {
  extractExportTypes,
  extractFileTypes,
  extractExportSubTypes,
};
